import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import * as Fi from 'react-icons/fi';
import cn from 'classnames';

// import { Uploader } from 'ui/components';
import { Skeletons, SkeletonText } from 'ui/components/skeleton';
import { Shipment } from 'services/action';
import { Uploader } from 'ui/components';
import { isNotClient } from 'utilities/common';

const initialState = {
  isShow: false,
  zoomImg: null,
  data: null,
  temp: null,
  imgShow: 7,
};

export const Document = ({ id, status, clientId, privilege }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Shipment.Get.Image']
  );

  const StateLoadingDelete = useSelector(
    (state) => state?.Activity?.services['Shipment.Delete.Image']
  );

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  const [{ data, isShow, zoomImg, imgShow }, setState] =
    React.useState(initialState);

  const $onLoad = async (id) => {
    const res = await Dispatch(Shipment.$getImage(id));

    if (res?.message === 'success') {
      setState((prevState) => ({ ...prevState, data: res?.data }));
    }
  };

  const $postImage = async (e) => {
    let payload = {
      shipment_id: id,
      images: e,
      type: 'shipment',
      latitude: 0,
      longitude: 0,
    };

    const req = await Dispatch(Shipment.$upload(payload));

    if (req?.message === 'success') {
      $onLoad(id);
    }
  };

  const $deleteImage = async (e) => {
    const req = await Dispatch(Shipment.$deleteImage(e));

    if (req?.message === 'success') {
      $onLoad(id);
      setState((prevState) => ({
        ...prevState,
        isShow: false,
      }));
    }
  };

  React.useEffect(() => {
    if (!id) return;
    $onLoad(id);
  }, [id]);

  if (!data && !privilege) return null;

  return (
    <section className="pt-2 mb-3" id="doc">
      {StateLoading ? (
        <div style={{ width: 250 }}>
          <SkeletonText count={1} />
        </div>
      ) : (
        <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
          Dokumentasi Pengiriman
        </div>
      )}

      {StateLoading ? (
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-center pt-2">
          {dummy?.map((d, i) => (
            <Skeletons width="50px" height="50px" key={i} />
          ))}
          <Skeletons width="50px" height="50px" />
        </div>
      ) : (
        <div
          className={cn(
            'd-flex flex-wrap pt-2',
            'gap-2 align-items-center justify-content-center'
          )}
        >
          {privilege && !isNotClient(Session?.client?.id, clientId) && (
            <>
              {status !== 'void' && (
                <Uploader small setData={(e) => $postImage(e)} />
              )}
            </>
          )}

          {data?.slice(0, imgShow)?.map((d, i) => (
            <div key={i} style={{ width: 50, height: 50 }}>
              <img
                className="img-hover small rounded-3"
                src={d?.image}
                alt=""
                onClick={() => {
                  setState((prevState) => ({
                    ...prevState,
                    isShow: true,
                    zoomImg: d,
                  }));
                }}
              />
            </div>
          ))}

          {data?.length > 7 ? (
            imgShow < data?.length ? (
              <div
                className="d-flex flex-column justify-content-center align-items-center bg-secondary-lt text-uppercase fw-bold rounded-3 uploader"
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    imgShow: data?.length,
                  }))
                }
                style={{ cursor: 'pointer', height: 50, width: 50 }}
              >
                <div
                  className=""
                  style={{
                    textOrientation: 'upright',
                    writingMode: 'horizontal-tb',
                    textAlign: 'center',
                    fontSize: 10,
                  }}
                >
                  <Fi.FiChevronsRight size={20} />
                </div>
              </div>
            ) : (
              <div
                className="d-flex flex-column justify-content-center align-items-center bg-secondary-lt text-uppercase fw-bold rounded-3 uploader"
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    imgShow: 7,
                  }))
                }
                style={{ cursor: 'pointer', height: 50, width: 50 }}
              >
                <div
                  className=""
                  style={{
                    textOrientation: 'upright',
                    writingMode: 'horizontal-tb',
                    textAlign: 'center',
                    fontSize: 10,
                  }}
                >
                  <Fi.FiChevronsLeft size={20} />
                </div>
              </div>
            )
          ) : null}
        </div>
      )}

      <Modal
        show={isShow}
        onHide={() =>
          setState((prevState) => ({
            ...prevState,
            isShow: false,
          }))
        }
        backdrop="static"
        centered
        className="text-center"
        size="lg"
      >
        <Modal.Body>
          <div
            className="btn-close"
            onClick={() =>
              setState((prevState) => ({
                ...prevState,
                isShow: false,
              }))
            }
          />
          <div className="text-center mt-4" style={{ maxHeight: 500 }}>
            <img
              src={zoomImg?.image?.replace('_thumb', '')}
              alt=""
              className="img-fluid"
              style={{ maxHeight: 500 }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          {
            !isNotClient(Session?.client?.id, clientId) && (
              <div
                className={
                  StateLoadingDelete
                    ? 'btn btn-danger btn-loading'
                    : 'btn btn-danger'
                }
                onClick={() => $deleteImage(zoomImg?.id)}
              >
                Hapus Gambar
              </div>
            )
          }
        </Modal.Footer>
      </Modal>
    </section>
  );
};
